<template>
    <v-row class="PrepareSignatureTopbar" align="center" no-gutters>
      <v-col class="pl-5 py-4">
        <AppTooltip>
          <template #activator="{ props }">
            <h4 class="PrepareSignatureTopbar-envelopeName text-text-primary" v-bind="props" data-locator="file-name">
              {{ envelopeName }}
            </h4>
          </template>
          <span>{{ envelopeName }}</span>
        </AppTooltip>
      </v-col>
      <v-col v-if="pagesCount > 0" class="text-right text-text-secondary pr-5 py-1" data-locator="page-selection">
        <span>{{ $t('common.page') }}</span>
        <input
          v-model="newPage"
          type="number"
          class="PrepareSignatureTopbar-pageInput"
          :class="{ 'input-error': newPage < 1 || newPage > pagesCount }"
          data-locator="page-number-input"
          :min="1"
          :max="pagesCount"
          v-on:input="newPage = $event.target.value"
          v-on:keydown.enter="scrollToPageNumber"
          v-on:change="onPageNumberChange"
        >
        <span data-locator="pages-count">{{ `/ ${pagesCount}` }}</span>
      </v-col>
    </v-row>
</template>

<script>
import { debounce } from 'lodash-es'
import { defineComponent } from 'vue'

import AppTooltip from '@/common/AppTooltip.vue'

export default defineComponent({
  name: 'PrepareSignatureTopbar',
  components: {
    AppTooltip,
  },
  emits: ['scroll-to'],
  props: {
    envelopeName: {
      type: String,
      default: '',
    },
    pagesCount: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: [Number, String],
      required: true,
    },
  },
  data () {
    return {
      newPage: this.currentPage,
    }
  },
  watch: {
    currentPage: function (newValue) {
      this.newPage = newValue
    },
  },
  created () {
    this.onPageNumberChange = debounce(this.onPageNumberChange, 800)
  },
  methods: {
    scrollToPageNumber () {
      if (this.newPage >= 1 && this.newPage <= this.pagesCount) {
        this.$emit('scroll-to', this.newPage)
      }
    },
    onPageNumberChange () {
      this.scrollToPageNumber()
    },
  },
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";
@import "@/scss/typography-tokens";

.PrepareSignatureTopbar {
  border: get-border();
  background-color: rgb(var(--v-theme-surface-primary));
  border-top-left-radius: get-radius('border-radius-3');
  border-top-right-radius: get-radius('border-radius-3');
}
.PrepareSignatureTopbar-envelopeName {
  max-width: 1000px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.PrepareSignatureTopbar-pageInput {
  @include text('body-md-regular');

  background: white;
  border: get-border('border-secondary');
  @include border-radius('border-radius-2');
  padding: 3px 10px;
  margin: 0 4px;
  max-width: 80px;
  outline:none;

  &.input-error {
    border: get-border('border-danger-bold');
  }
}
</style>
